import { useState, useEffect } from "react";
import { MapPin, Trash2, Plus, Star } from "lucide-react";
import { toast } from "sonner";

const DEFAULT = [
  { id: 1, name: "Galvenā noliktava", address: "Demo iela 5, Demo pilsēta, LV-0000", primary: true },
  { id: 2, name: "Birojs centrā", address: "Parauga bulvāris 10, Demo pilsēta, LV-0001", primary: false },
  { id: 3, name: "Filiāle (2. objekts)", address: "Testa iela 3, Cita pilsēta, LV-0002", primary: false },
];

export default function AccAddresses() {
  const [list, setList] = useState(() => {
    try { return JSON.parse(localStorage.getItem("demo_addresses")) || DEFAULT; } catch { return DEFAULT; }
  });
  const [form, setForm] = useState({ name: "", address: "" });
  useEffect(() => { localStorage.setItem("demo_addresses", JSON.stringify(list)); }, [list]);

  const add = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.address.trim()) return;
    setList((p) => [...p, { id: Date.now(), ...form, primary: false }]);
    setForm({ name: "", address: "" });
    toast.success("Adrese pievienota");
  };
  const del = (id) => { setList((p) => p.filter((a) => a.id !== id)); toast.success("Adrese dzēsta"); };
  const setPrimary = (id) => setList((p) => p.map((a) => ({ ...a, primary: a.id === id })));

  return (
    <div data-testid="account-addresses">
      <h2 className="text-xl font-extrabold uppercase mb-4">Piegādes adreses ({list.length})</h2>
      <p className="text-sm text-[#6B6B6B] mb-4">Vienā pasūtījumā vari norādīt piegādi uz vairākām adresēm (B2B funkcija).</p>
      <div className="space-y-3 mb-6">
        {list.map((a) => (
          <div key={a.id} className="border border-[#E2E2E2] p-4 flex items-start gap-3" data-testid={`address-${a.id}`}>
            <MapPin size={18} className="text-[#D0121A] shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-bold flex items-center gap-2">
                {a.name}
                {a.primary && <span className="text-[10px] font-bold uppercase tracking-wider bg-[#111111] text-white px-1.5 py-0.5">Noklusējuma</span>}
              </div>
              <div className="text-sm text-[#6B6B6B] mt-0.5">{a.address}</div>
            </div>
            <div className="flex gap-2 shrink-0">
              {!a.primary && (
                <button onClick={() => setPrimary(a.id)} data-testid={`address-primary-${a.id}`} title="Iestatīt kā noklusējuma"
                  className="p-1.5 hover:bg-[#F5F5F5] text-[#6B6B6B] hover:text-[#111111]"><Star size={15} /></button>
              )}
              <button onClick={() => del(a.id)} data-testid={`address-delete-${a.id}`} aria-label="Dzēst"
                className="p-1.5 hover:bg-[#F5F5F5] text-[#D0121A]"><Trash2 size={15} /></button>
            </div>
          </div>
        ))}
      </div>
      <form onSubmit={add} className="bg-[#F5F5F5] p-5 space-y-3" data-testid="address-add-form">
        <h3 className="text-sm font-bold uppercase tracking-widest">Pievienot jaunu adresi</h3>
        <div className="grid sm:grid-cols-2 gap-3">
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nosaukums (piem., Noliktava)" data-testid="address-name-input"
            className="h-10 px-3 border border-[#E2E2E2] text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#111111]" />
          <input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} placeholder="Iela, māja, pilsēta, indekss" data-testid="address-address-input"
            className="h-10 px-3 border border-[#E2E2E2] text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#111111]" />
        </div>
        <button type="submit" data-testid="address-add-btn" className="bg-[#111111] hover:bg-[#3A3A3A] text-white text-sm font-bold px-5 py-2.5 flex items-center gap-1.5 transition-colors">
          <Plus size={14} /> Pievienot adresi
        </button>
      </form>
    </div>
  );
}
